export const ALL_EMAILS = "ALL_EMAILS";
export const ALL_EMAILS_COUNT = "ALL_EMAILS_COUNT";
